import { IntlShape } from 'react-intl'
import { MofiSortType, SortDirectionDTO } from '../../apis'
import { ParkingEventsSortType } from '../../apis/parkingEvents/dto'
import { WhitelistSortType } from '../../apis/whitelist/dto'

type SortType = 'PARKING_EVENTS_ONGOING' | 'PARKING_EVENTS_ENDED' | 'WHITELIST'

export const getSortItems = (
  intl: IntlShape,
  sortType: SortType,
): { key: string; value: string }[] => {
  const getLocalizedItems = (
    sortType: SortType,
    keys: ParkingEventsSortType[] | WhitelistSortType[],
  ) => {
    return keys.map((key) => ({
      key: key.toString(),
      value: intl.formatMessage({
        id: `sort.${sortType}.${key}`,
      }),
    }))
  }

  switch (sortType) {
    case 'PARKING_EVENTS_ONGOING': {
      const keys: ParkingEventsSortType[] = [
        'LICENSE_PLATE',
        'START',
        'DURATION',
        'ENTRY_LANE',
      ]
      return getLocalizedItems(sortType, keys)
    }
    case 'PARKING_EVENTS_ENDED': {
      const keys: ParkingEventsSortType[] = [
        'LICENSE_PLATE',
        'START',
        'END',
        'DURATION',
        'PRICE',
        'PAYMENT',
      ]
      return getLocalizedItems(sortType, keys)
    }
    case 'WHITELIST': {
      const keys: WhitelistSortType[] = ['LICENSE_PLATE', 'NAME', 'CREATED_AT']
      return getLocalizedItems(sortType, keys)
    }
    default:
      return []
  }
}

export const getSortDirection = (sortKey: MofiSortType): SortDirectionDTO => {
  const parkingEventsDescKeys: ParkingEventsSortType[] = [
    'PRICE',
    'DURATION',
    'START',
    'END',
  ]
  const whitelistDescKeys: WhitelistSortType[] = ['CREATED_AT']

  if (
    parkingEventsDescKeys.includes(sortKey as ParkingEventsSortType) ||
    whitelistDescKeys.includes(sortKey as WhitelistSortType)
  ) {
    return 'DESC'
  }

  return 'ASC'
}
